<template>
  <router-link
    :to="Cul(to)"
    class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
  >
    <span class="svg-icon svg-icon-md svg-icon-primary">
      <inline-svg src="/media/svg/icons/Navigation/Arrow-left.svg"></inline-svg>
    </span>
  </router-link>
</template>
<script>
export default {
  props: {
    to: String,
  },
};
</script>
